export const presetEventNames = {
  SET_SELECT_SITE: 'SET_SELECT_SITE',
  SET_SELECT_DATA_TYPE: 'SET_SELECT_DATA_TYPE',
  SET_SELECT_PRESET: 'SET_SELECT_PRESET',
  SET_SELECT_GET_DATA_BY: 'SET_GET_DATA_BY',
  SET_SELECT_CONTRACTS: 'SET_SELECT_CONTRACTS',
};

const PresetEventEmitter = {
  _events: {},
  dispatch: async function(event, data) {
    if (!Object.values(presetEventNames).includes(event) || !this._events[event]) return;
    for(let callback of this._events[event]) {
      try {
        await callback(data);
      } catch(error) {
        console.error('Error while executing event callback:', error);
      }
    }
  },    
  subscribe: function(event, callback) {
    if(!Object.values(presetEventNames).includes(event)) { return }
    if(!this._events[event]) this._events[event] = [];
    this._events[event].push(callback);
  },
  unsubscribe: function(event, callback) {
    if(!Object.values(presetEventNames).includes(event)) { return }
    const callbackIndex = this._events[event].findIndex(_callback => _callback === callback);
    if(callbackIndex === -1) { return }
    this._events[event].splice(callbackIndex, 1);
  }
};

export default PresetEventEmitter;